import { FileWithPath } from '@mantine/dropzone';

import { Project } from '@/shared/config/projects';
import { projectAxios } from '@/shared/core/axios';

type UploadEntity = 'books' | 'categories' | 'publishers';
type UploadFileType = 'epub' | 'image';

export async function uploadKitabaFile(
  file: FileWithPath | File,
  entity: UploadEntity,
  fileType: UploadFileType,
): Promise<{ path: string; url: string }> {
  const formData = new FormData();
  formData.append('file', file);

  return (
    await projectAxios.kitaba.post('/file/upload', formData, {
      headers: {
        Entity: entity,
        Filetype: fileType,
      },
    })
  ).data;
}

export function getProjectClient(project: Project) {
  return projectAxios[project];
}
